// @ts-ignore no declarations found for module
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { useEmbeddedEditorContext } from 'campaigns-lib/embedded/EmbeddedEditorContext';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AppReadyComponent = ({
  children,
  fallbackComponent,
  isReady,
  isUniversalAppReady
}) => {
  const {
    handleAppIsReady
  } = useEmbeddedEditorContext();
  const isActuallyReady = isReady && !EditorConfigSingleton.getIsOnScalableEditor() || isUniversalAppReady;
  useEffect(() => {
    if (isActuallyReady) {
      handleAppIsReady === null || handleAppIsReady === void 0 || handleAppIsReady();
    }
  }, [isActuallyReady, handleAppIsReady]);
  if (isActuallyReady) {
    return children;
  }
  return fallbackComponent || /*#__PURE__*/_jsx("span", {});
};
export default AppReadyComponent;